import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const grouprole = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/account/{profile}/group-role',
    app: 'account'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'account', model: 'grouprole' }
    ),
    { }
  )
)()

export { grouprole, TYPES }
